/** Settings tab submodule query value (`?submodule=…`). */
export const USER_MANAGEMENT_SETTINGS_SUBMODULE = 'user_management_settings';

/** Users tab submodule query value (`?submodule=…`). */
export const USER_MANAGEMENT_USERS_SUBMODULE = 'user_management_users';

/** Tool Access tab submodule query value (`?submodule=…`). */
export const USER_MANAGEMENT_TOOL_ACCESS_SUBMODULE = 'user_management_tool_access';

/** Bulk Upload tab submodule query value (`?submodule=…`). */
export const USER_MANAGEMENT_BULK_UPLOAD_SUBMODULE = 'user_management_bulk_upload';

/** Access Review tab submodule query value (`?submodule=…`) — TROC-352. */
export const USER_MANAGEMENT_ACCESS_REVIEW_SUBMODULE = 'access_review';

export function isUserManagementToolAccessDeepLink(submodule: string | null | undefined): boolean {
  return submodule === USER_MANAGEMENT_TOOL_ACCESS_SUBMODULE;
}

export function isUserManagementSettingsDeepLink(submodule: string | null | undefined): boolean {
  return submodule === USER_MANAGEMENT_SETTINGS_SUBMODULE;
}

export function isUserManagementBulkUploadDeepLink(submodule: string | null | undefined): boolean {
  return submodule === USER_MANAGEMENT_BULK_UPLOAD_SUBMODULE;
}

export function isUserManagementAccessReviewDeepLink(submodule: string | null | undefined): boolean {
  return submodule === USER_MANAGEMENT_ACCESS_REVIEW_SUBMODULE;
}
